import PropTypes from 'prop-types'
import c from 'classnames'
import styles from './BackBtn.module.scss'
import IconLink from '@components/atoms/IconLink/IconLink'
import Translate from '@components/atoms/Translate/Translate'

const BackBtn = ({ link, color }) => (
  <div className={c(styles.base, `c-a-${color}`, 'u-ml')}>
    <IconLink link={link} icon="arrow-long-left" whiteIcon={color === 'white'}>
      <Translate str="global.back" />
    </IconLink>
    {/* <Link to={link}>
      <div className={styles.inner}>
        <div className={styles.icon}>
          <i
            className={`icon icon-arrow-long-left ${
              color === 'white' ? 'c-white' : 'c-brand'
            }`}
          />
        </div>
        <div className={styles.text}>
          <Text type="nav">
            <Translate str="global.back" />
          </Text>
        </div>
      </div>
    </Link> */}
  </div>
)

BackBtn.defaultProps = {
  color: 'dark',
}
BackBtn.propTypes = {
  link: PropTypes.string.isRequired,
  color: PropTypes.oneOf(['dark', 'white']),
}

export default BackBtn
